import { attachComponent } from 'higgins-domain'

import { htmlHotspotComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain'

import { ReplaceButton } from '../ui/ReplaceButton'

export const segmentComponents = [
  attachComponent
    .withComponent(htmlHotspotComponent, 'actionButtons')
    .withAlias('NonWallCabinetSegment')
    .withGradualFilter({
      selectedEntityIds: s => [s.id],
      modes: ['owner'],
    })
    .attach(
      memoEval(
        s => [s, s.$fabCenteredOffsetX, s.$fabOffsetY],
        (entity, fabCenteredOffsetX, fabOffsetY) => {
          return {
            offsetX: fabCenteredOffsetX,
            offsetY: fabOffsetY - 5,
            offsetZ: 12,
            unit: 'inch',
            node: <ReplaceButton entityId={entity.id} />,
            controlHotspot: true,
            showWhen: ['selected'],
          }
        }
      )
    ),
]
